import styled from "styled-components";
import { motion } from "framer-motion";
import Button from "../../../components/Atoms/Button";
import { tokens } from "../../../design/tokens";

export const Container = styled.div`
  /* width: 100vw; */
  max-width: 100%;
  height: 100vh;

  @media (max-width: 768px) {
    min-height: 100vh;
    height: auto;
    padding: 2rem 0 0 0;
  }
`;

export const ContentWrapper = styled.main`
  width: 100%;
  max-width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100%;
  }
`;

export const LoginWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 ${tokens.space.lg};
  }

  /* O <Form> e um item flex de uma coluna com align-items: center, entao ele
     encolhia para a largura do conteudo (~299px) e o max-width de 380px do
     FormWrapper nunca chegava a valer — os campos ficavam em 224px, apertado
     para um e-mail. Declarar a largura aqui e o que faz a coluna documentada
     no DESIGN.md realmente existir. */
  .formStyle {
    width: 100%;
    max-width: 380px;

    @media (max-width: 425px) {
      max-width: 100%;
    }
  }
`;

/* O logo do cliente navega para a home. Era uma imagem nua com onClick: uma
   rota que so existia para quem usa mouse. Como botao ele entra na ordem de
   tabulacao e responde a Enter/Espaco, sem mudar nada visualmente. */
export const LogoButton = styled.button`
  display: block;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  img {
    display: block;
    height: 120px;
    margin-bottom: ${tokens.space.lg};
  }
`;

export const LogoWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  width: 50%;

  img {
    width: 100%;
    max-width: 100%;
    height: 100vh;

    /* Sem isto a imagem era esticada para preencher metade da viewport em
       qualquer proporcao de tela — a marca de cinco escolas reais renderizava
       deformada, e o quanto dependia da janela de cada aluno. */
    object-fit: cover;
    object-position: center;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;

    img {
      height: auto;
    }
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  max-width: 380px;

  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xl};
  align-items: center;

  padding: ${tokens.space.lg} 0;

  @media (max-width: 768px) {
    max-width: 100%;
  }

  /* Input e Button trazem margin-top propria, herdada de telas que empilham
     por margem. Aqui quem empilha e o gap acima, e as duas coisas se somavam:
     a coluna alternava entre 20px e 36px. Zerar so aqui preserva o
     espacamento de todas as outras telas do produto.
     Ver "A Regra do Gap sobre a Margem" no DESIGN.md. */
  && > div,
  && > button {
    margin-top: 0;
  }

  h1 {
    font-family: ${tokens.font.title.family};
    font-size: ${tokens.font.title.size};
    font-weight: ${tokens.font.title.weight};
    color: ${tokens.color.textWhite};
    letter-spacing: -0.02em;
    margin: 0;
    text-align: center;
  }

  && .forgot {
    border: none;
    background: none;
    cursor: pointer;
    color: ${tokens.color.textMist};
    font-family: ${tokens.font.body.family};
    /* Estava em caption (12px), o tamanho de metadado de card. Isto nao e
       metadado: e a rota de recuperacao de conta, e quem precisa dela ja
       chegou errando a senha. Corpo (14px) mantem a escala documentada e
       ainda deixa o link claramente atras dos dois botoes em ouro. */
    font-size: ${tokens.font.body.size};
    font-weight: ${tokens.font.label.weight};
    transition: color 0.3s;

    /* O alvo era a altura da linha de 12px (~14px). E a rota de recuperacao
       de conta: o controle que o usuario mais precisa acertar quando ja esta
       frustrado era o mais dificil de acertar da tela. O padding cresce a
       area de toque e as margens negativas cancelam o crescimento no layout,
       entao o ritmo da coluna nao muda — mesma tecnica do icone de senha. */
    padding: 8px 12px;
    margin: -8px -12px;

    &:hover {
      color: ${tokens.color.focusAmber};
    }
  }
`;

/* Campos e acoes dividem a largura da coluna. Antes cada botao tinha a largura
   do proprio rotulo — "ENTRAR" em 104px ao lado de "CRIE UMA CONTA" em 190px,
   sob campos de outra largura ainda — e a coluna ficava com tres bordas
   direitas diferentes. */
export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
